import React, { useRef } from 'react';
import './chapters.scss';
import InlinePhotos from '../InlinePhotos/InlinePhotos';
import Float from '../Float/Float';

function Chapter3() {
  const inline2Ref = useRef();
  const inline3Ref = useRef();
  const float2Ref = useRef();

  return (
    <div className="chapters__chapter">
      <h3>The Dawn of a New Reality</h3>
      <p className="chapters__chapter__paragraph">
        Ben’s early life was marked by tragedy: He lost his father to heart disease at a young age.
        In the wake of that loss, Ben’s mother, who was already battling severe mental illness, went
        into a downward spiral. She couldn’t find effective treatment and was unable to fully care
        for her son. Ben was well into adulthood before he came to terms with his own mental health
        struggles. In 2018, he was living by himself in New York City, working as an IT consultant,
        when depression began to interfere with his work and daily life.
      </p>
      <p className="chapters__chapter__paragraph">
        “When you’re going through that spiral,” Ben recalls, “you can’t see your hand in front of
        your face.”
      </p>
      <p className="chapters__chapter__paragraph">
        Ben reached out to his sister, who helped him find a psychiatrist. “I let it all out,” Ben
        says. “Family stuff, dead parents, all the things.” The psychiatrist diagnosed Ben with
        clinical depression and gave him a prescription for an oral antidepressant.
      </p>
      <InlinePhotos index={2} inlineRef={inline2Ref} />
      <p className="chapters__chapter__paragraph">
        Similarly, Grace also had a hard time grappling with her diagnosis of clinical depression,
        but in her own way. “People would say, ‘Why are you not happy? ...You have everything,’ and
        they weren’t wrong... I was into sports. I had a very supportive family.”
      </p>
      <div className="chapters__chapter__float">
        <Float index={1} floatRef={float2Ref} />
        <p className="chapters__chapter__paragraph">
          Grace’s periods of clinical depression were few and far between — until she left home for
          college. Grace attended the same university where many of her family members had thrived.
          She expected to do the same. However, Grace’s time in college was marked, instead, by
          ever-worsening depression. “I had always been told that college is the best four years of
          your life,” she says. “I felt like if I told people that wasn’t happening for me, then I
          was just a complete and total failure.” Partying provided a temporary escape for Grace,
          but eventually, it became too much. Grace dropped out of school, moved back home, and
          began receiving treatment for her depression.
        </p>
      </div>
      <p className="chapters__chapter__paragraph">
        Allison remembers vividly when she first realized her son Austin might need help. Austin had
        been a perfectionist since a young age. He was a straight-A high-school student who had
        already secured a college scholarship. But after Austin went through a serious break-up,
        something changed.
      </p>
      <p className="chapters__chapter__paragraph">
        “Suddenly, he went from never wanting to miss a day of school, to not wanting to go to
        school at all,” Allison says. Austin had been through tough times before and Allison was
        confident her son would recover. Eventually, Austin missed so much school a truancy officer
        showed up on their doorstep. That’s when Allison came to a hard realization: “He was in
        danger of losing the scholarship he’d worked his whole academic career to obtain. I knew I
        had to work quickly.”
      </p>
      <InlinePhotos index={3} inlineRef={inline3Ref} />
      <p className="chapters__chapter__paragraph">
        Allison and Austin lived in rural Kentucky, a two-hour drive from the nearest city. The
        stigma around mental health in Allison’s small community made asking for help difficult, but
        Allison was determined. She found a therapist and psychiatrist for Austin who she calls “the
        dream team.” “He’s still with that dream team today,” she adds.
      </p>
    </div>
  );
}

export default Chapter3;
